import { useRouter } from 'next/router'
import React from 'react'
import { useInstantSearch } from 'react-instantsearch'

import cn from 'classnames'
import CheckboxIcon from 'public/images/icons/checkbox-checked.svg'

import Checkbox from 'components/checkbox'
import css from 'components/molecules/refinement-list-customized/refinement-list-customized.module.scss'

import { MAP_ALGOLIA_INSIGHTS_TO_GTM_TRIGGER } from 'utils/search/insights'
import { fireTrackingEvent } from 'utils/tracking'

import { FilterQuery } from './constants'
import { toggleQueryParam } from './utils'

export type RefinementByQueryProps = {
  label: string
  filterQuery: FilterQuery
}

const RefinementByQuery = ({ filterQuery, label }: RefinementByQueryProps) => {
  const { name, queryOnValue, attribute } = filterQuery
  const router = useRouter()
  const { results } = useInstantSearch()

  const isSelected = router.query[name] === queryOnValue
  return (
    <div className={cn([css.container, css.containerRefinementByQuery])}>
      <ul className={css.refinementListList}>
        <li className={cn([css.refinementListItem, isSelected && css.refinementListSelectedItem])}>
          <label className={css.refinementListLabel}>
            <Checkbox
              id={name}
              name={name}
              className={css.checkboxInput}
              isChecked={isSelected}
              onChange={() => {
                !isSelected &&
                  fireTrackingEvent('track', {
                    event: MAP_ALGOLIA_INSIGHTS_TO_GTM_TRIGGER.clickedFilters,
                    insightsMethod: 'clickedFilters',
                    index: results.index,
                    filters: [attribute],
                  })
                toggleQueryParam(router, name, queryOnValue)
              }}
              CheckedIcon={<CheckboxIcon />}
            />
            <p className={css.refinementListLabelText}>{label}</p>
          </label>
        </li>
      </ul>
    </div>
  )
}

export default RefinementByQuery
